import millify from 'millify';

/**
 * Format the number in human-readable approximation.
 *
 * Numbers lower than `10 000` are not abbreviated. Numbers between `10 000` and `100 000` are abbreviated with a precision of `1`. Numbers higher than `100 000` are abbreviated with a precision of `0`.
 * For example: 18462 becomes 18.5K , 87308 becomes 87.3K , 465352 becomes 465K , 794854 becomes 795K
 * @param theNumber a number to format
 * @returns a string with the formatted value.
 * @remarks Note that when the decimal number is `0`, it is discarded, for example `11 000` becomes `11K` and not `11.0K`. This is a limitation of the library.
 */
export const formatNumberApprox = (theNumber: number): string => {
    if (theNumber < 1000) return String(theNumber);

    // see https://github.com/izolate/millify/blob/master/README.md#options for options
    return millify(theNumber, {
        precision: theNumber < 10000000000 ? 1 : 0,
        locales: 'en-US', // We use en-US locale because we want a dot as decimal separator
    });
};
